"use client";

import React from "react";
import { Button } from "antd";
import { useRouter } from "next/navigation";

// Auth-aware call-to-action shared by the hero, product cards, pricing cards, and
// the final CTA. It reads the auth token directly from localStorage on click and
// routes to the dashboard (signed in) or the login flow (signed out). It does NOT
// use AuthProvider/useAuth and fires no network request, so it renders instantly
// with no loading flicker — even on pages without an AuthProvider ancestor.

const goGetStarted = (router: ReturnType<typeof useRouter>) => {
  const token =
    typeof window !== "undefined" ? window.localStorage.getItem("token") : null;
  router.push(token ? "/dashboard" : "/login");
};

interface GetStartedButtonProps {
  children: React.ReactNode;
  className?: string;
  type?: "primary" | "default";
  style?: React.CSSProperties;
}

export const GetStartedButton = ({
  children,
  className,
  type = "primary",
  style,
}: GetStartedButtonProps) => {
  const router = useRouter();
  return (
    <Button
      type={type}
      className={className}
      style={style}
      onClick={() => goGetStarted(router)}
    >
      {children}
    </Button>
  );
};

interface GetStartedLinkProps {
  children: React.ReactNode;
  className?: string;
}

export const GetStartedLink = ({ children, className }: GetStartedLinkProps) => {
  const router = useRouter();
  return (
    <a
      className={className}
      role="button"
      onClick={() => goGetStarted(router)}
      style={{ cursor: "pointer" }}
    >
      {children}
    </a>
  );
};
